import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';


const __default__ = {
    name: 'ResultMessage'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

// computed
const isVisible = computed({
    get() {
        return store.getters['snackbar/isVisible'];
    },
    set() {
        store.dispatch('snackbar/hideSnackbar');
    }
});
const message = computed(() => store.getters['snackbar/text']);
const timeout = computed(() => store.getters['snackbar/timeout']);
const multiline = computed(() => store.getters['snackbar/multiline']);
const color = computed(() => {
    const type = store.getters['snackbar/type'];
    if (type === 'failure') return 'red';
    if (type === 'success') return 'success';
    return null;
});

// methods
const closeSnackbar = () => store.dispatch('snackbar/hideSnackbar');

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _unref(isVisible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : null)),
    "multi-line": _unref(multiline),
    color: _unref(color),
    timeout: _unref(timeout)
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        onClick: closeSnackbar,
        class: "d-none d-sm-block",
        color: "white",
        variant: "text"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('commonUI.resultMessage.closeBtn')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: closeSnackbar,
        class: "d-block d-sm-none",
        icon: "",
        color: "white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(message)) + " ", 1)
    ]),
    _: 1
  }, 8, ["modelValue", "multi-line", "color", "timeout"]))
}
}

})